import React, { useState, useEffect } from 'react'

import { toDataURL } from './qrcode-lib'
import { FormHelperText, TextField } from '@material-ui/core'
import { appendRequired } from 'app/reusable/utils'

const QRCode = ({ name, value, field, onChange, errors, testingClassName }) => {
  const [qrContent, setQrContent] = useState(null)
  useEffect(() => {
    toDataURL(value).then(setQrContent)
  }, [value])

  if (!qrContent) return null
  return (
    <>
      <div className="text-center">
        {qrContent && <img src={qrContent} alt="QR Code" />}
      </div>
      <TextField
        disabled={field.widget.attrs.disabled}
        helperText={
          !!(errors || field.help_text) && (
            <FormHelperText className="mb-3">
              {errors ? errors.join(', ') : field.help_text}
            </FormHelperText>
          )
        }
        name={name}
        error={errors?.length}
        className={testingClassName}
        fullWidth
        variant="outlined"
        label={appendRequired(field.label, field.required)}
        value={value || ''}
        size="small"
        inputProps={{
          maxLength: field.max_length,
        }}
        // TODO: Add copy to clipboard button
      />
    </>
  )
}

export default QRCode
